/* eslint-disable react/no-danger */
import React from 'react';
import { buildArticleSchema } from './SchemaArticle.utils';
import { SchemaArticleProps } from './SchemaArticle.types';

const SchemaArticle = (props: SchemaArticleProps) => {
  const structuredData = buildArticleSchema(props);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
    />
  );
};

export default SchemaArticle;
